import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class HydraulicMatrix implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES:
        ' 62 03 B8 01 09 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 01 01 00 00 00 00 00 00 00 00 02 01 03 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0020_HPMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0020_HPMU_CAN01',
      request_parameter_value: VddNames.HydraulicMatrix,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'HydraulicMatrix',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_CountOfHeatEngin',
              unit: '',
              translationid: 'TI_CountOfHeatEngine',
              dopname: '1 Byte Identical uint8',
              name: 'PA_CountOfHeatEngin',
              value: '1',
            },
            {
              semantic: '',
              path: 'PA_DataRecor/PA_HeatEnginProceData',
              translationid: 'TI_HeatEngineProcessData',
              dopname: 'EOPF HeatEngine',
              name: 'PA_HeatEnginProceData',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                  name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                      unit: '',
                      translationid: 'TI_HeatEngineHydraulicType',
                      dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                      name: 'PA_HeatEnginHydraType',
                      value: 'Nothing',
                    },
                  ],
                },
              ],
            },
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_CountOfDomesHotWaterCylin',
              unit: '',
              translationid: 'TI_CountOfDomesticHotWaterCylinder',
              dopname: '1 Byte Identical uint8',
              name: 'PA_CountOfDomesHotWaterCylin',
              value: '1',
            },
            {
              semantic: '',
              path: 'PA_DataRecor/PA_DomesHotWaterCylinProceData',
              translationid: 'TI_DomesticHotWaterCylinderProcessData',
              dopname: 'EOPF DomesticHotWaterCylinder',
              name: 'PA_DomesHotWaterCylinProceData',
              structure: [
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                  name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                      unit: '',
                      translationid: 'TI_DomesticHotWaterCylinder',
                      dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                      name: 'PA_DomesHotWaterCylin',
                      value: 'DomesticHotWaterCylinderWithSensor',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                  name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                      unit: '',
                      translationid: 'TI_DomesticHotWaterCylinder',
                      dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                      name: 'PA_DomesHotWaterCylin',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                  name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                      unit: '',
                      translationid: 'TI_DomesticHotWaterCylinder',
                      dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                      name: 'PA_DomesHotWaterCylin',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                  name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                      unit: '',
                      translationid: 'TI_DomesticHotWaterCylinder',
                      dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                      name: 'PA_DomesHotWaterCylin',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                  name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                      unit: '',
                      translationid: 'TI_DomesticHotWaterCylinder',
                      dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                      name: 'PA_DomesHotWaterCylin',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                  name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                      unit: '',
                      translationid: 'TI_DomesticHotWaterCylinder',
                      dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                      name: 'PA_DomesHotWaterCylin',
                      value: 'Nothing',
                    },
                  ],
                },
              ],
            },
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_CountOfHydraSepar',
              unit: '',
              translationid: 'TI_CountOfHydraulicSeparator',
              dopname: '1 Byte Identical uint8',
              name: 'PA_CountOfHydraSepar',
              value: '0',
            },
            {
              semantic: '',
              path: 'PA_DataRecor/PA_HydraSeparProceData',
              translationid: 'TI_HydraulicSeparatorProcessData',
              dopname: 'EOPF HydraulicSeparator',
              name: 'PA_HydraSeparProceData',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HydraSeparProceData/STR_1ByteStrucHydraSeparTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HydraulicSeparatorTypeProperty',
                  name: 'STR_1ByteStrucHydraSeparTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HydraSeparProceData/STR_1ByteStrucHydraSeparTypePrope/PA_HydraSepar',
                      unit: '',
                      translationid: 'TI_HydraulicSeparator',
                      dopname: '1 Byte TextTable HydraulicSeparatorTypeProperty',
                      name: 'PA_HydraSepar',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_HydraSeparProceData/STR_1ByteStrucHydraSeparTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure HydraulicSeparatorTypeProperty',
                  name: 'STR_1ByteStrucHydraSeparTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_HydraSeparProceData/STR_1ByteStrucHydraSeparTypePrope/PA_HydraSepar',
                      unit: '',
                      translationid: 'TI_HydraulicSeparator',
                      dopname: '1 Byte TextTable HydraulicSeparatorTypeProperty',
                      name: 'PA_HydraSepar',
                      value: 'Nothing',
                    },
                  ],
                },
              ],
            },
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_CountOfCentrHeatiCircu',
              unit: '',
              translationid: 'TI_CountOfCentralHeatingCircuit',
              dopname: '1 Byte Identical uint8',
              name: 'PA_CountOfCentrHeatiCircu',
              value: '2',
            },
            {
              semantic: '',
              path: 'PA_DataRecor/PA_CentrHeatiCircuProceData',
              translationid: 'TI_CentralHeatingCircuitProcessData',
              dopname: 'EOPF CentralHeatingCircuit',
              name: 'PA_CentrHeatiCircuProceData',
              structure: [
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'DirectCircuit',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'MixedCircuitWithPump',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path:
                    'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                  name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                      unit: '',
                      translationid: 'TI_CentralHeatingCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                      name: 'PA_CentrHeatiCircu',
                      value: 'Nothing',
                    },
                  ],
                },
              ],
            },
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_CountOfSolarCircu',
              unit: '',
              translationid: 'TI_CountOfSolarCircuit',
              dopname: '1 Byte Identical uint8',
              name: 'PA_CountOfSolarCircu',
              value: '0',
            },
            {
              semantic: '',
              path: 'PA_DataRecor/PA_SolarCircuProceData',
              translationid: 'TI_SolarCircuitProcessData',
              dopname: 'EOPF SolarCircuit',
              name: 'PA_SolarCircuProceData',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure SolarCircuitTypeProperty',
                  name: 'STR_1ByteStrucSolarCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                      unit: '',
                      translationid: 'TI_SolarCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                      name: 'PA_SolarCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure SolarCircuitTypeProperty',
                  name: 'STR_1ByteStrucSolarCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                      unit: '',
                      translationid: 'TI_SolarCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                      name: 'PA_SolarCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure SolarCircuitTypeProperty',
                  name: 'STR_1ByteStrucSolarCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                      unit: '',
                      translationid: 'TI_SolarCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                      name: 'PA_SolarCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure SolarCircuitTypeProperty',
                  name: 'STR_1ByteStrucSolarCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                      unit: '',
                      translationid: 'TI_SolarCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                      name: 'PA_SolarCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure SolarCircuitTypeProperty',
                  name: 'STR_1ByteStrucSolarCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                      unit: '',
                      translationid: 'TI_SolarCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                      name: 'PA_SolarCircu',
                      value: 'Nothing',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                  translationid: '',
                  dopname: '1 Byte Structure SolarCircuitTypeProperty',
                  name: 'STR_1ByteStrucSolarCircuTypePrope',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path:
                        'PA_DataRecor/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                      unit: '',
                      translationid: 'TI_SolarCircuit',
                      dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                      name: 'PA_SolarCircu',
                      value: 'Nothing',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 03 B8',
    };
  }

  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0020_HPMU_CAN01',
      request_parameter_value: VddNames.HydraulicMatrix,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '952',
          value: 'HydraulicMatrix',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '0',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_False', interval: '0', texttableentry: 'False' },
                { TI_texttableentry: 'TI_True', interval: '1', texttableentry: 'True' },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'True',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }

  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0020_HPMU_CAN01',
          request_parameter_value: VddNames.HydraulicMatrix,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '952',
              value: 'HydraulicMatrix',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'ENTRIES',
                  longname: 'CountOfHeatEngine',
                  byteposition: '0',
                  dopname: '1 Byte Identical uint8',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_CountOfHeatEngin',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_CountOfHeatEngin',
                  unit: '',
                  translationid: 'TI_CountOfHeatEngine',
                  bitposition: '0',
                  name: 'PA_CountOfHeatEngin',
                  value: '0',
                },
                {
                  semantic: '',
                  longname: 'HeatEngineProcessData',
                  byteposition: '1',
                  dopname: 'EOPF HeatEngine',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_HeatEnginProceData',
                  constraints: '[16:16]',
                  structure: [
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HeatEngineHydraulicTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HeatEngineHydraulicType',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HeatEngineHydraulicTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginHydraType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithoutPump',
                              interval: '1',
                              texttableentry: 'HeatingWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPump',
                              interval: '2',
                              texttableentry: 'HeatingWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingWithPumpDomesticHotWaterWithPump',
                              interval: '3',
                              texttableentry: 'HeatingWithPumpDomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingAndDomesticHotWaterWithOnePump',
                              interval: '4',
                              texttableentry: 'HeatingAndDomesticHotWaterWithOnePump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterWithPump',
                              interval: '5',
                              texttableentry: 'DomesticHotWaterWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '6',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWaySplit',
                              interval: '7',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplit',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '8',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDomesticHotWaterTwoPumpFourWayMono',
                              interval: '9',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMono',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                              interval: '10',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                              interval: '11',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWaySplitWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                              interval: '12',
                              texttableentry: 'HeatingDomesticHotWaterOnePumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                              interval: '13',
                              texttableentry: 'HeatingDomesticHotWaterTwoPumpFourWayMonoWoHeater',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                              interval: '14',
                              texttableentry: 'HybdridHeatingDomesticHotWaterOnePumpFourWaySplit',
                            },
                            {
                              TI_texttableentry:
                                'TI_HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                              interval: '15',
                              texttableentry: 'HybridHeatingDomesticHotWaterOnePumpFourWayMono',
                            },
                            {
                              TI_texttableentry: 'TI_IceStorage',
                              interval: '16',
                              texttableentry: 'IceStorage',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope/PA_HeatEnginHydraType',
                          unit: '',
                          translationid: 'TI_HeatEngineHydraulicType',
                          bitposition: '0',
                          name: 'PA_HeatEnginHydraType',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HeatEnginProceData/STR_1ByteStrucHeatEnginHydraTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHeatEnginHydraTypePrope',
                      value: '1',
                    },
                  ],
                  path: 'PA_Struc/PA_HeatEnginProceData',
                  unit: '',
                  translationid: 'TI_HeatEngineProcessData',
                  bitposition: '0',
                  name: 'PA_HeatEnginProceData',
                  value: '1',
                },
                {
                  semantic: 'ENTRIES',
                  longname: 'CountOfDomesticHotWaterCylinder',
                  byteposition: '17',
                  dopname: '1 Byte Identical uint8',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_CountOfDomesHotWaterCylin',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_CountOfDomesHotWaterCylin',
                  unit: '',
                  translationid: 'TI_CountOfDomesticHotWaterCylinder',
                  bitposition: '0',
                  name: 'PA_CountOfDomesHotWaterCylin',
                  value: '0',
                },
                {
                  semantic: '',
                  longname: 'DomesticHotWaterCylinderProcessData',
                  byteposition: '18',
                  dopname: 'EOPF DomesticHotWaterCylinder',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_DomesHotWaterCylinProceData',
                  constraints: '[6:6]',
                  structure: [
                    {
                      semantic: '',
                      longname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'DomesticHotWaterCylinder',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DomesHotWaterCylin',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSensor',
                              interval: '1',
                              texttableentry: 'DomesticHotWaterCylinderWithSensor',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithTwoSensors',
                              interval: '2',
                              texttableentry: 'DomesticHotWaterCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                              interval: '3',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry: 'TI_CirculationPumpOnly',
                              interval: '4',
                              texttableentry: 'CirculationPumpOnly',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSensorAndCirculationPump',
                              interval: '5',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                              interval: '6',
                              texttableentry:
                                'DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                              interval: '7',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadCylinderWithSensor',
                              interval: '8',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                              interval: '9',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                              interval: '10',
                              texttableentry:
                                'DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSwitchedInput',
                              interval: '11',
                              texttableentry: 'DomesticHotWaterCylinderWithSwitchedInput',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                              interval: '12',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderSensorEHeater',
                              interval: '13',
                              texttableentry: 'DomesticHotWaterCylinderSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderTwoSensorEHeater',
                              interval: '14',
                              texttableentry: 'DomesticHotWaterCylinderTwoSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithoutSensor',
                              interval: '15',
                              texttableentry: 'DomesticHotWaterCylinderWithoutSensor',
                            },
                          ],
                          path:
                            'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                          unit: '',
                          translationid: 'TI_DomesticHotWaterCylinder',
                          bitposition: '0',
                          name: 'PA_DomesHotWaterCylin',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'DomesticHotWaterCylinder',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DomesHotWaterCylin',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSensor',
                              interval: '1',
                              texttableentry: 'DomesticHotWaterCylinderWithSensor',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithTwoSensors',
                              interval: '2',
                              texttableentry: 'DomesticHotWaterCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                              interval: '3',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry: 'TI_CirculationPumpOnly',
                              interval: '4',
                              texttableentry: 'CirculationPumpOnly',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSensorAndCirculationPump',
                              interval: '5',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                              interval: '6',
                              texttableentry:
                                'DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                              interval: '7',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadCylinderWithSensor',
                              interval: '8',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                              interval: '9',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                              interval: '10',
                              texttableentry:
                                'DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSwitchedInput',
                              interval: '11',
                              texttableentry: 'DomesticHotWaterCylinderWithSwitchedInput',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                              interval: '12',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderSensorEHeater',
                              interval: '13',
                              texttableentry: 'DomesticHotWaterCylinderSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderTwoSensorEHeater',
                              interval: '14',
                              texttableentry: 'DomesticHotWaterCylinderTwoSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithoutSensor',
                              interval: '15',
                              texttableentry: 'DomesticHotWaterCylinderWithoutSensor',
                            },
                          ],
                          path:
                            'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                          unit: '',
                          translationid: 'TI_DomesticHotWaterCylinder',
                          bitposition: '0',
                          name: 'PA_DomesHotWaterCylin',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'DomesticHotWaterCylinder',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DomesHotWaterCylin',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSensor',
                              interval: '1',
                              texttableentry: 'DomesticHotWaterCylinderWithSensor',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithTwoSensors',
                              interval: '2',
                              texttableentry: 'DomesticHotWaterCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                              interval: '3',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry: 'TI_CirculationPumpOnly',
                              interval: '4',
                              texttableentry: 'CirculationPumpOnly',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSensorAndCirculationPump',
                              interval: '5',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                              interval: '6',
                              texttableentry:
                                'DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                              interval: '7',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadCylinderWithSensor',
                              interval: '8',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                              interval: '9',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                              interval: '10',
                              texttableentry:
                                'DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSwitchedInput',
                              interval: '11',
                              texttableentry: 'DomesticHotWaterCylinderWithSwitchedInput',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                              interval: '12',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderSensorEHeater',
                              interval: '13',
                              texttableentry: 'DomesticHotWaterCylinderSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderTwoSensorEHeater',
                              interval: '14',
                              texttableentry: 'DomesticHotWaterCylinderTwoSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithoutSensor',
                              interval: '15',
                              texttableentry: 'DomesticHotWaterCylinderWithoutSensor',
                            },
                          ],
                          path:
                            'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                          unit: '',
                          translationid: 'TI_DomesticHotWaterCylinder',
                          bitposition: '0',
                          name: 'PA_DomesHotWaterCylin',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'DomesticHotWaterCylinder',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DomesHotWaterCylin',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSensor',
                              interval: '1',
                              texttableentry: 'DomesticHotWaterCylinderWithSensor',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithTwoSensors',
                              interval: '2',
                              texttableentry: 'DomesticHotWaterCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                              interval: '3',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry: 'TI_CirculationPumpOnly',
                              interval: '4',
                              texttableentry: 'CirculationPumpOnly',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSensorAndCirculationPump',
                              interval: '5',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                              interval: '6',
                              texttableentry:
                                'DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                              interval: '7',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadCylinderWithSensor',
                              interval: '8',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                              interval: '9',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                              interval: '10',
                              texttableentry:
                                'DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSwitchedInput',
                              interval: '11',
                              texttableentry: 'DomesticHotWaterCylinderWithSwitchedInput',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                              interval: '12',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderSensorEHeater',
                              interval: '13',
                              texttableentry: 'DomesticHotWaterCylinderSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderTwoSensorEHeater',
                              interval: '14',
                              texttableentry: 'DomesticHotWaterCylinderTwoSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithoutSensor',
                              interval: '15',
                              texttableentry: 'DomesticHotWaterCylinderWithoutSensor',
                            },
                          ],
                          path:
                            'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                          unit: '',
                          translationid: 'TI_DomesticHotWaterCylinder',
                          bitposition: '0',
                          name: 'PA_DomesHotWaterCylin',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'DomesticHotWaterCylinder',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DomesHotWaterCylin',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSensor',
                              interval: '1',
                              texttableentry: 'DomesticHotWaterCylinderWithSensor',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithTwoSensors',
                              interval: '2',
                              texttableentry: 'DomesticHotWaterCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                              interval: '3',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry: 'TI_CirculationPumpOnly',
                              interval: '4',
                              texttableentry: 'CirculationPumpOnly',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSensorAndCirculationPump',
                              interval: '5',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                              interval: '6',
                              texttableentry:
                                'DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                              interval: '7',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadCylinderWithSensor',
                              interval: '8',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                              interval: '9',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                              interval: '10',
                              texttableentry:
                                'DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSwitchedInput',
                              interval: '11',
                              texttableentry: 'DomesticHotWaterCylinderWithSwitchedInput',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                              interval: '12',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderSensorEHeater',
                              interval: '13',
                              texttableentry: 'DomesticHotWaterCylinderSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderTwoSensorEHeater',
                              interval: '14',
                              texttableentry: 'DomesticHotWaterCylinderTwoSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithoutSensor',
                              interval: '15',
                              texttableentry: 'DomesticHotWaterCylinderWithoutSensor',
                            },
                          ],
                          path:
                            'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                          unit: '',
                          translationid: 'TI_DomesticHotWaterCylinder',
                          bitposition: '0',
                          name: 'PA_DomesHotWaterCylin',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure DomesticHotWaterCylinderTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'DomesticHotWaterCylinder',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixDomesticHotWaterCylinder',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DomesHotWaterCylin',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSensor',
                              interval: '1',
                              texttableentry: 'DomesticHotWaterCylinderWithSensor',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithTwoSensors',
                              interval: '2',
                              texttableentry: 'DomesticHotWaterCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                              interval: '3',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithTwoSensors',
                            },
                            {
                              TI_texttableentry: 'TI_CirculationPumpOnly',
                              interval: '4',
                              texttableentry: 'CirculationPumpOnly',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSensorAndCirculationPump',
                              interval: '5',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                              interval: '6',
                              texttableentry:
                                'DomesticHotWaterCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                              interval: '7',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithTwoSensorsAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadCylinderWithSensor',
                              interval: '8',
                              texttableentry: 'DomesticHotWaterShiftLoadCylinderWithSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                              interval: '9',
                              texttableentry:
                                'DomesticHotWaterShiftLoadCylinderWithSensorAndCirculationPump',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                              interval: '10',
                              texttableentry:
                                'DomesticHotWaterHeaterInstantaneousWithComfortFunction',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithSwitchedInput',
                              interval: '11',
                              texttableentry: 'DomesticHotWaterCylinderWithSwitchedInput',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                              interval: '12',
                              texttableentry:
                                'DomesticHotWaterCylinderWithSwitchedInputAndCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderSensorEHeater',
                              interval: '13',
                              texttableentry: 'DomesticHotWaterCylinderSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderTwoSensorEHeater',
                              interval: '14',
                              texttableentry: 'DomesticHotWaterCylinderTwoSensorEHeater',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderWithoutSensor',
                              interval: '15',
                              texttableentry: 'DomesticHotWaterCylinderWithoutSensor',
                            },
                          ],
                          path:
                            'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope/PA_DomesHotWaterCylin',
                          unit: '',
                          translationid: 'TI_DomesticHotWaterCylinder',
                          bitposition: '0',
                          name: 'PA_DomesHotWaterCylin',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_DomesHotWaterCylinProceData/STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucDomesHotWaterCylinTypePrope',
                      value: '1',
                    },
                  ],
                  path: 'PA_Struc/PA_DomesHotWaterCylinProceData',
                  unit: '',
                  translationid: 'TI_DomesticHotWaterCylinderProcessData',
                  bitposition: '0',
                  name: 'PA_DomesHotWaterCylinProceData',
                  value: '1',
                },
                {
                  semantic: 'ENTRIES',
                  longname: 'CountOfHydraulicSeparator',
                  byteposition: '24',
                  dopname: '1 Byte Identical uint8',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_CountOfHydraSepar',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_CountOfHydraSepar',
                  unit: '',
                  translationid: 'TI_CountOfHydraulicSeparator',
                  bitposition: '0',
                  name: 'PA_CountOfHydraSepar',
                  value: '0',
                },
                {
                  semantic: '',
                  longname: 'HydraulicSeparatorProcessData',
                  byteposition: '25',
                  dopname: 'EOPF HydraulicSeparator',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_HydraSeparProceData',
                  constraints: '[2:2]',
                  structure: [
                    {
                      semantic: '',
                      longname: '1 Byte Structure HydraulicSeparatorTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HydraulicSeparatorTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHydraSeparTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HydraulicSeparator',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicSeparatorTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HydraSepar',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_OnlyHeating',
                              interval: '1',
                              texttableentry: 'OnlyHeating',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderInFrontOfSeparator',
                              interval: '2',
                              texttableentry: 'DomesticHotWaterCylinderInFrontOfSeparator',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderBehindOfSeparator',
                              interval: '3',
                              texttableentry: 'DomesticHotWaterCylinderBehindOfSeparator',
                            },
                            {
                              TI_texttableentry: 'TI_BufferOnlyHeating',
                              interval: '4',
                              texttableentry: 'BufferOnlyHeating',
                            },
                            {
                              TI_texttableentry:
                                'TI_BufferDomesticHotWaterCylinderInFrontOfSeparator',
                              interval: '5',
                              texttableentry: 'BufferDomesticHotWaterCylinderInFrontOfSeparator',
                            },
                            {
                              TI_texttableentry: 'TI_BufferDomesticHotWaterCylinderBehindSeparator',
                              interval: '6',
                              texttableentry: 'BufferDomesticHotWaterCylinderBehindSeparator',
                            },
                            {
                              TI_texttableentry: 'TI_OnlyHeatingWithoutSensor',
                              interval: '7',
                              texttableentry: 'OnlyHeatingWithoutSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderInFrontOfSeparatorWithoutSensor',
                              interval: '8',
                              texttableentry:
                                'DomesticHotWaterCylinderInFrontOfSeparatorWithoutSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderBehindOfSeparatorWithoutSensor',
                              interval: '9',
                              texttableentry:
                                'DomesticHotWaterCylinderBehindOfSeparatorWithoutSensor',
                            },
                            {
                              TI_texttableentry: 'TI_BufferOnlyHeatingWithoutSensor',
                              interval: '10',
                              texttableentry: 'BufferOnlyHeatingWithoutSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_BufferDomesticHotWaterCylinderInFrontOfSeparatorWithoutSensor',
                              interval: '11',
                              texttableentry:
                                'BufferDomesticHotWaterCylinderInFrontOfSeparatorWithoutSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_BufferDomesticHotWaterCylinderBehindSeparatorWithoutSensor',
                              interval: '12',
                              texttableentry:
                                'BufferDomesticHotWaterCylinderBehindSeparatorWithoutSensor',
                            },
                            {
                              TI_texttableentry: 'TI_BufferHeatingAndCooling',
                              interval: '13',
                              texttableentry: 'BufferHeatingAndCooling',
                            },
                            {
                              TI_texttableentry: 'TI_BufferOnlyCooling',
                              interval: '14',
                              texttableentry: 'BufferOnlyCooling',
                            },
                            {
                              TI_texttableentry: 'TI_ExtensionHeatingAndCooling',
                              interval: '15',
                              texttableentry: 'ExtensionHeatingAndCooling',
                            },
                            {
                              TI_texttableentry: 'TI_ExternalBivalenceMixer',
                              interval: '16',
                              texttableentry: 'ExternalBivalenceMixer',
                            },
                            {
                              TI_texttableentry: 'TI_BufferHeatingWithDomestivHotWaterCombined',
                              interval: '17',
                              texttableentry: 'BufferHeatingWithDomestivHotWaterCombined',
                            },
                            {
                              TI_texttableentry: 'TI_BufferHeatingWithDomesticHotWaterHybrid',
                              interval: '18',
                              texttableentry: 'BufferHeatingWithDomesticHotWaterHybrid',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HydraSeparProceData/STR_1ByteStrucHydraSeparTypePrope/PA_HydraSepar',
                          unit: '',
                          translationid: 'TI_HydraulicSeparator',
                          bitposition: '0',
                          name: 'PA_HydraSepar',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HydraSeparProceData/STR_1ByteStrucHydraSeparTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHydraSeparTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure HydraulicSeparatorTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure HydraulicSeparatorTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucHydraSeparTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'HydraulicSeparator',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicSeparatorTypeProperty',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HydraSepar',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_OnlyHeating',
                              interval: '1',
                              texttableentry: 'OnlyHeating',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderInFrontOfSeparator',
                              interval: '2',
                              texttableentry: 'DomesticHotWaterCylinderInFrontOfSeparator',
                            },
                            {
                              TI_texttableentry: 'TI_DomesticHotWaterCylinderBehindOfSeparator',
                              interval: '3',
                              texttableentry: 'DomesticHotWaterCylinderBehindOfSeparator',
                            },
                            {
                              TI_texttableentry: 'TI_BufferOnlyHeating',
                              interval: '4',
                              texttableentry: 'BufferOnlyHeating',
                            },
                            {
                              TI_texttableentry:
                                'TI_BufferDomesticHotWaterCylinderInFrontOfSeparator',
                              interval: '5',
                              texttableentry: 'BufferDomesticHotWaterCylinderInFrontOfSeparator',
                            },
                            {
                              TI_texttableentry: 'TI_BufferDomesticHotWaterCylinderBehindSeparator',
                              interval: '6',
                              texttableentry: 'BufferDomesticHotWaterCylinderBehindSeparator',
                            },
                            {
                              TI_texttableentry: 'TI_OnlyHeatingWithoutSensor',
                              interval: '7',
                              texttableentry: 'OnlyHeatingWithoutSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderInFrontOfSeparatorWithoutSensor',
                              interval: '8',
                              texttableentry:
                                'DomesticHotWaterCylinderInFrontOfSeparatorWithoutSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_DomesticHotWaterCylinderBehindOfSeparatorWithoutSensor',
                              interval: '9',
                              texttableentry:
                                'DomesticHotWaterCylinderBehindOfSeparatorWithoutSensor',
                            },
                            {
                              TI_texttableentry: 'TI_BufferOnlyHeatingWithoutSensor',
                              interval: '10',
                              texttableentry: 'BufferOnlyHeatingWithoutSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_BufferDomesticHotWaterCylinderInFrontOfSeparatorWithoutSensor',
                              interval: '11',
                              texttableentry:
                                'BufferDomesticHotWaterCylinderInFrontOfSeparatorWithoutSensor',
                            },
                            {
                              TI_texttableentry:
                                'TI_BufferDomesticHotWaterCylinderBehindSeparatorWithoutSensor',
                              interval: '12',
                              texttableentry:
                                'BufferDomesticHotWaterCylinderBehindSeparatorWithoutSensor',
                            },
                            {
                              TI_texttableentry: 'TI_BufferHeatingAndCooling',
                              interval: '13',
                              texttableentry: 'BufferHeatingAndCooling',
                            },
                            {
                              TI_texttableentry: 'TI_BufferOnlyCooling',
                              interval: '14',
                              texttableentry: 'BufferOnlyCooling',
                            },
                            {
                              TI_texttableentry: 'TI_ExtensionHeatingAndCooling',
                              interval: '15',
                              texttableentry: 'ExtensionHeatingAndCooling',
                            },
                            {
                              TI_texttableentry: 'TI_ExternalBivalenceMixer',
                              interval: '16',
                              texttableentry: 'ExternalBivalenceMixer',
                            },
                            {
                              TI_texttableentry: 'TI_BufferHeatingWithDomestivHotWaterCombined',
                              interval: '17',
                              texttableentry: 'BufferHeatingWithDomestivHotWaterCombined',
                            },
                            {
                              TI_texttableentry: 'TI_BufferHeatingWithDomesticHotWaterHybrid',
                              interval: '18',
                              texttableentry: 'BufferHeatingWithDomesticHotWaterHybrid',
                            },
                          ],
                          path:
                            'PA_Struc/PA_HydraSeparProceData/STR_1ByteStrucHydraSeparTypePrope/PA_HydraSepar',
                          unit: '',
                          translationid: 'TI_HydraulicSeparator',
                          bitposition: '0',
                          name: 'PA_HydraSepar',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_HydraSeparProceData/STR_1ByteStrucHydraSeparTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucHydraSeparTypePrope',
                      value: '1',
                    },
                  ],
                  path: 'PA_Struc/PA_HydraSeparProceData',
                  unit: '',
                  translationid: 'TI_HydraulicSeparatorProcessData',
                  bitposition: '0',
                  name: 'PA_HydraSeparProceData',
                  value: '1',
                },
                {
                  semantic: 'ENTRIES',
                  longname: 'CountOfCentralHeatingCircuit',
                  byteposition: '27',
                  dopname: '1 Byte Identical uint8',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_CountOfCentrHeatiCircu',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_CountOfCentrHeatiCircu',
                  unit: '',
                  translationid: 'TI_CountOfCentralHeatingCircuit',
                  bitposition: '0',
                  name: 'PA_CountOfCentrHeatiCircu',
                  value: '0',
                },
                {
                  semantic: '',
                  longname: 'CentralHeatingCircuitProcessData',
                  byteposition: '28',
                  dopname: 'EOPF CentralHeatingCircuit',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_CentrHeatiCircuProceData',
                  constraints: '[16:16]',
                  structure: [
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure CentralHeatingCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'CentralHeatingCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixCentralHeatingCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_CentrHeatiCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuit',
                              interval: '1',
                              texttableentry: 'DirectCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithoutPump',
                              interval: '2',
                              texttableentry: 'MixedCircuitWithoutPump',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPump',
                              interval: '3',
                              texttableentry: 'MixedCircuitWithPump',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithZoneSupport',
                              interval: '5',
                              texttableentry: 'DirectCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithZoneSupport',
                              interval: '6',
                              texttableentry: 'MixedCircuitWithZoneSupport',
                            },
                            {
                              TI_texttableentry: 'TI_ThermostatTerminalCircuit',
                              interval: '7',
                              texttableentry: 'ThermostatTerminalCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitCooling',
                              interval: '8',
                              texttableentry: 'DirectCircuitCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitHeatingCooling',
                              interval: '9',
                              texttableentry: 'DirectCircuitHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpCooling',
                              interval: '10',
                              texttableentry: 'MixedCircuitWithPumpCooling',
                            },
                            {
                              TI_texttableentry: 'TI_MixedCircuitWithPumpHeatingCooling',
                              interval: '11',
                              texttableentry: 'MixedCircuitWithPumpHeatingCooling',
                            },
                            {
                              TI_texttableentry: 'TI_DirectCircuitWithPump',
                              interval: '12',
                              texttableentry: 'DirectCircuitWithPump',
                            },
                          ],
                          path:
                            'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope/PA_CentrHeatiCircu',
                          unit: '',
                          translationid: 'TI_CentralHeatingCircuit',
                          bitposition: '0',
                          name: 'PA_CentrHeatiCircu',
                          value: 'Nothing',
                        },
                      ],
                      path:
                        'PA_Struc/PA_CentrHeatiCircuProceData/STR_1ByteStrucCentrHeatiCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucCentrHeatiCircuTypePrope',
                      value: '1',
                    },
                  ],
                  path: 'PA_Struc/PA_CentrHeatiCircuProceData',
                  unit: '',
                  translationid: 'TI_CentralHeatingCircuitProcessData',
                  bitposition: '0',
                  name: 'PA_CentrHeatiCircuProceData',
                  value: '1',
                },
                {
                  semantic: 'ENTRIES',
                  longname: 'CountOfSolarCircuit',
                  byteposition: '44',
                  dopname: '1 Byte Identical uint8',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_CountOfSolarCircu',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_CountOfSolarCircu',
                  unit: '',
                  translationid: 'TI_CountOfSolarCircuit',
                  bitposition: '0',
                  name: 'PA_CountOfSolarCircu',
                  value: '0',
                },
                {
                  semantic: '',
                  longname: 'SolarCircuitProcessData',
                  byteposition: '45',
                  dopname: 'EOPF SolarCircuit',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_SolarCircuProceData',
                  constraints: '[6:6]',
                  structure: [
                    {
                      semantic: '',
                      longname: '1 Byte Structure SolarCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure SolarCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucSolarCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'SolarCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_SolarCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_Basic',
                              interval: '1',
                              texttableentry: 'Basic',
                            },
                            {
                              TI_texttableentry:
                                'TI_SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                              interval: '2',
                              texttableentry:
                                'SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                            },
                            {
                              TI_texttableentry: 'TI_SecondaryDifferentialTemperatureController',
                              interval: '3',
                              texttableentry: 'SecondaryDifferentialTemperatureController',
                            },
                            {
                              TI_texttableentry: 'TI_PreheatingWithTwoStepController',
                              interval: '4',
                              texttableentry: 'PreheatingWithTwoStepController',
                            },
                            {
                              TI_texttableentry: 'TI_AlternatingChargeOfTwoBuffers',
                              interval: '5',
                              texttableentry: 'AlternatingChargeOfTwoBuffers',
                            },
                          ],
                          path:
                            'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                          unit: '',
                          translationid: 'TI_SolarCircuit',
                          bitposition: '0',
                          name: 'PA_SolarCircu',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucSolarCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure SolarCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure SolarCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucSolarCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'SolarCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_SolarCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_Basic',
                              interval: '1',
                              texttableentry: 'Basic',
                            },
                            {
                              TI_texttableentry:
                                'TI_SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                              interval: '2',
                              texttableentry:
                                'SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                            },
                            {
                              TI_texttableentry: 'TI_SecondaryDifferentialTemperatureController',
                              interval: '3',
                              texttableentry: 'SecondaryDifferentialTemperatureController',
                            },
                            {
                              TI_texttableentry: 'TI_PreheatingWithTwoStepController',
                              interval: '4',
                              texttableentry: 'PreheatingWithTwoStepController',
                            },
                            {
                              TI_texttableentry: 'TI_AlternatingChargeOfTwoBuffers',
                              interval: '5',
                              texttableentry: 'AlternatingChargeOfTwoBuffers',
                            },
                          ],
                          path:
                            'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                          unit: '',
                          translationid: 'TI_SolarCircuit',
                          bitposition: '0',
                          name: 'PA_SolarCircu',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucSolarCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure SolarCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure SolarCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucSolarCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'SolarCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_SolarCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_Basic',
                              interval: '1',
                              texttableentry: 'Basic',
                            },
                            {
                              TI_texttableentry:
                                'TI_SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                              interval: '2',
                              texttableentry:
                                'SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                            },
                            {
                              TI_texttableentry: 'TI_SecondaryDifferentialTemperatureController',
                              interval: '3',
                              texttableentry: 'SecondaryDifferentialTemperatureController',
                            },
                            {
                              TI_texttableentry: 'TI_PreheatingWithTwoStepController',
                              interval: '4',
                              texttableentry: 'PreheatingWithTwoStepController',
                            },
                            {
                              TI_texttableentry: 'TI_AlternatingChargeOfTwoBuffers',
                              interval: '5',
                              texttableentry: 'AlternatingChargeOfTwoBuffers',
                            },
                          ],
                          path:
                            'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                          unit: '',
                          translationid: 'TI_SolarCircuit',
                          bitposition: '0',
                          name: 'PA_SolarCircu',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucSolarCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure SolarCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure SolarCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucSolarCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'SolarCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_SolarCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_Basic',
                              interval: '1',
                              texttableentry: 'Basic',
                            },
                            {
                              TI_texttableentry:
                                'TI_SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                              interval: '2',
                              texttableentry:
                                'SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                            },
                            {
                              TI_texttableentry: 'TI_SecondaryDifferentialTemperatureController',
                              interval: '3',
                              texttableentry: 'SecondaryDifferentialTemperatureController',
                            },
                            {
                              TI_texttableentry: 'TI_PreheatingWithTwoStepController',
                              interval: '4',
                              texttableentry: 'PreheatingWithTwoStepController',
                            },
                            {
                              TI_texttableentry: 'TI_AlternatingChargeOfTwoBuffers',
                              interval: '5',
                              texttableentry: 'AlternatingChargeOfTwoBuffers',
                            },
                          ],
                          path:
                            'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                          unit: '',
                          translationid: 'TI_SolarCircuit',
                          bitposition: '0',
                          name: 'PA_SolarCircu',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucSolarCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure SolarCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure SolarCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucSolarCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'SolarCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_SolarCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_Basic',
                              interval: '1',
                              texttableentry: 'Basic',
                            },
                            {
                              TI_texttableentry:
                                'TI_SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                              interval: '2',
                              texttableentry:
                                'SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                            },
                            {
                              TI_texttableentry: 'TI_SecondaryDifferentialTemperatureController',
                              interval: '3',
                              texttableentry: 'SecondaryDifferentialTemperatureController',
                            },
                            {
                              TI_texttableentry: 'TI_PreheatingWithTwoStepController',
                              interval: '4',
                              texttableentry: 'PreheatingWithTwoStepController',
                            },
                            {
                              TI_texttableentry: 'TI_AlternatingChargeOfTwoBuffers',
                              interval: '5',
                              texttableentry: 'AlternatingChargeOfTwoBuffers',
                            },
                          ],
                          path:
                            'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                          unit: '',
                          translationid: 'TI_SolarCircuit',
                          bitposition: '0',
                          name: 'PA_SolarCircu',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucSolarCircuTypePrope',
                      value: '1',
                    },
                    {
                      semantic: '',
                      longname: '1 Byte Structure SolarCircuitTypeProperty',
                      byteposition: '-1',
                      dopname: '1 Byte Structure SolarCircuitTypeProperty',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_1ByteStrucSolarCircuTypePrope',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          longname: 'SolarCircuit',
                          byteposition: '0',
                          dopname: '1 Byte TextTable HydraulicMatrixSolarCircuit',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_SolarCircu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Nothing',
                              interval: '0',
                              texttableentry: 'Nothing',
                            },
                            {
                              TI_texttableentry: 'TI_Basic',
                              interval: '1',
                              texttableentry: 'Basic',
                            },
                            {
                              TI_texttableentry:
                                'TI_SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                              interval: '2',
                              texttableentry:
                                'SecondaryDifferentialTemperatureControllerWithHeatingSuppression',
                            },
                            {
                              TI_texttableentry: 'TI_SecondaryDifferentialTemperatureController',
                              interval: '3',
                              texttableentry: 'SecondaryDifferentialTemperatureController',
                            },
                            {
                              TI_texttableentry: 'TI_PreheatingWithTwoStepController',
                              interval: '4',
                              texttableentry: 'PreheatingWithTwoStepController',
                            },
                            {
                              TI_texttableentry: 'TI_AlternatingChargeOfTwoBuffers',
                              interval: '5',
                              texttableentry: 'AlternatingChargeOfTwoBuffers',
                            },
                          ],
                          path:
                            'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope/PA_SolarCircu',
                          unit: '',
                          translationid: 'TI_SolarCircuit',
                          bitposition: '0',
                          name: 'PA_SolarCircu',
                          value: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_SolarCircuProceData/STR_1ByteStrucSolarCircuTypePrope',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_1ByteStrucSolarCircuTypePrope',
                      value: '1',
                    },
                  ],
                  path: 'PA_Struc/PA_SolarCircuProceData',
                  unit: '',
                  translationid: 'TI_SolarCircuitProcessData',
                  bitposition: '0',
                  name: 'PA_SolarCircuProceData',
                  value: '1',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
